export enum OPEN_HUB_MODES {
  PICK_UP = 'PICK_UP',
  DEPOSIT = 'DEPOSIT',
}
